export default {
  PlayerHighlight: false,
  HubPages: false,
  MatchdayTakeover: false,
  TempSocialFeed: false,
  WhereToStream: false,
  PlayerProfileStats: false
}
